import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';

interface AnnouncerState {
    text: string | null;
}

const initialState: AnnouncerState = {
    text: null,
};

const announcerSlice = createSlice({
    name: 'announcer',
    initialState,
    reducers: {
        setText: (state, { payload }: PayloadAction<string | null>) => {
            state.text = payload;
        },
        clearText: state => {
            state.text = null;
        },
    },
});

export const getAnnouncerState = (state: RootState) => state.announcer;

export const getAnnouncement = createSelector(
    [getAnnouncerState],
    state => state.text
);

export const announcerInitialState = announcerSlice.getInitialState();
export const announcerReducer = announcerSlice.reducer;
export const { setText, clearText } = announcerSlice.actions;
